import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Button } from "../ui/button";
import { Eye, FileText, Pencil, Trash2, Check } from "lucide-react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ReservationPDF from "../ReservationPDF";

const formatMoney = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 }).format(Number(n) || 0);

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleString("es-MX", { dateStyle: "short", timeStyle: "short" }); } catch { return iso; }
};

const RES_BADGE = {
  pending: "bg-amber-100 text-amber-800",
  approved: "bg-emerald-100 text-emerald-800",
  rejected: "bg-red-100 text-red-800",
};

export default function ReservationsTable({ items, userRole, onView, onEdit, onDelete, onApprove }) {
  if (!items.length) {
    return <div className="border border-dashed border-slate-300 rounded-md p-10 text-center text-slate-500">Aún no hay reservas registradas.</div>;
  }
  return (
    <div className="border border-slate-200 rounded-md bg-white overflow-x-auto">
      <Table data-testid="reservations-table">
        <TableHeader>
          <TableRow>
            <TableHead># Reserva</TableHead>
            <TableHead>Lote</TableHead>
            <TableHead>Cliente</TableHead>
            <TableHead>Detalles</TableHead>
            <TableHead>Fecha</TableHead>
            <TableHead>Estado</TableHead>
            <TableHead className="text-right">Acciones</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((r) => (
            <TableRow key={r.id}>
              <TableCell className="font-mono text-xs">#{r.reservation_id}</TableCell>
              <TableCell className="font-medium">{r.lot_label}</TableCell>
              <TableCell>
                <div className="font-medium text-slate-700">
                  {r.cliente?.nombre ? `${r.cliente.nombre} ${r.cliente.apellido_paterno}` : `ID Cliente: ${r.id_client}`}
                </div>
                <div className="text-[10px] text-slate-500">{r.cliente?.email}</div>
              </TableCell>
              <TableCell className="text-xs">
                {r.contributions && r.contributions.total_contribution > 0 && (
                  <div className="text-slate-600"><span className="font-medium">Aportación:</span> {formatMoney(r.contributions.total_contribution)}</div>
                )}
                {r.promoter && r.promoter.name && (
                  <div className="text-slate-500"><span className="font-medium">Promotor:</span> {r.promoter.name}</div>
                )}
                {r.notes && <div className="text-slate-500 truncate max-w-[150px]">{r.notes}</div>}
              </TableCell>
              <TableCell className="text-xs text-slate-500">{fmtDate(r.created_at)}</TableCell>
              <TableCell>
                <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${RES_BADGE[r.status]}`}>
                  {r.status === "pending" ? "Pendiente" : r.status === "approved" ? "Aprobada" : "Rechazada"}
                </span>
              </TableCell>
              <TableCell className="text-right">
                <div className="inline-flex gap-1">
                  {userRole === "admin" && r.status === "pending" && (
                    <Button size="sm" variant="outline" className="text-emerald-700 border-emerald-200 hover:bg-emerald-50 h-8 px-2" onClick={() => onApprove(r.reservation_id || r.id)} title="Aprobar Venta">
                      <Check size={14} />
                    </Button>
                  )}
                  <Button size="sm" variant="outline" className="text-blue-700 border-blue-200 hover:bg-blue-50 h-8 px-2" onClick={() => onView(r)} title="Ver detalles">
                    <Eye size={14} />
                  </Button>
                  <Button size="sm" variant="outline" className="text-slate-700 border-slate-200 hover:bg-slate-50 h-8 px-2" title="Descargar PDF">
                    <PDFDownloadLink document={<ReservationPDF reservation={r} />} fileName={`solicitud_reserva_${r.id_lots}.pdf`}>
                      {({ loading }) => (loading ? "..." : <FileText size={14} />)}
                    </PDFDownloadLink>
                  </Button>
                  <Button size="sm" variant="outline" className="text-amber-700 border-amber-200 hover:bg-amber-50 h-8 px-2" onClick={() => onEdit(r)} title="Editar">
                    <Pencil size={14} />
                  </Button>
                  <Button size="sm" variant="outline" className="text-red-600 border-red-300 hover:bg-red-50 h-8 px-2" onClick={() => onDelete(r.reservation_id || r.id)} title={userRole === "admin" ? "Eliminar" : "Cancelar Reserva"}>
                    <Trash2 size={14} />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}